import { FC, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useResetAtom } from "jotai/utils";
import { Avatar, Divider } from "antd";

import styles from "./headerCard.module.css";
import { Button } from "../../../customs";
import { profileDetails, userAtom } from "../../../utils/store";

import { ReactComponent as SignOutIcon } from "../../../assets/svgs/sign-out.svg";
import { getMemberPersonalDetailCall } from "../../helpers";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue, useSetAtom } from "jotai";

interface ComponentProps {
  firstName: string;
  profilePicture: string;
}

const HeaderCard: FC<ComponentProps> = ({ firstName, profilePicture }) => {
  const resetUser = useResetAtom(userAtom);
  const resetUserDetails = useResetAtom(profileDetails);
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);
  const setUserProfileDetails = useSetAtom(profileDetails);
  const membershipId = user?.MemberId;

  const handleLogOut = () => {
    // resetUser();
    // resetUserDetails()
    localStorage.removeItem("e-voting-member-user");
    localStorage.removeItem("e-voting-member-token");
    localStorage.removeItem("e-voting-profile-details");
    window.location.href = "/";
  };

  // const {
  //   data: memberData,
  //   isLoading,
  //   isError,
  //   error,
  //   isSuccess
  // } = useQuery({
  //   queryKey: ["get-member-data"],
  //   queryFn: () => getMemberPersonalDetailCall(membershipId),
  //   refetchOnWindowFocus: false,
  //   enabled: !!membershipId,
  // });
  // const userDetails = memberData?.Data;

  // useEffect(() => {
  //   if (userDetails !== null && isSuccess) {
  //     setUserProfileDetails({
  //       FirstName: userDetails?.FirstName ?? "",
  //       MembershipNo: userDetails?.MembershipNo ?? "",
  //       UploadPictureUrl: userDetails?.UploadPictureUrl ?? "",
  //       MiddleName: userDetails?.MiddleName ?? "",
  //       LastName: userDetails?.LastName ?? "",
  //       Email: userDetails?.Email ?? "",
  //       PhoneNumber: userDetails?.PhoneNumber ?? "",
  //       Name: userDetails?.Name ?? "",
  //       Gender: userDetails?.Gender ?? "",
  //       MembershipType: userDetails?.MembershipType ?? "",
  //       DateBirth: userDetails?.DateBirth ?? "",
  //       WhatsAppNumber: userDetails?.WhatsappNumber ?? "",
  //       ResidentialAddress: userDetails?.ResidentialAddress ?? "",
  //       StateId: userDetails?.StateId ?? "",
  //       StateOriginId: userDetails?.StateOriginId ?? "",
  //       LicenseExpire: userDetails?.LicenseExpire ?? "",
  //       CreatedDate: userDetails?.CreatedDate ?? "",
  //     });
  //   }
  // }, [userDetails, setUserProfileDetails]);
  return (
    <div className={styles.container}>
      <div>
        <Avatar src={profilePicture} size={60} />

        <div>
          <h3>{firstName}</h3>

          <Link to="/profile">
            <p>View Profile</p>
          </Link>
        </div>
      </div>

      <Divider className={styles.divider} />

      <Button variant="naked" color="#67686D" onClick={handleLogOut}>
        <div className={styles.buttonWrapper}>
          <SignOutIcon />

          <p>Log Out</p>
        </div>
      </Button>
    </div>
  );
};

export default HeaderCard;
